import { defineMessages } from 'react-intl'

const messages = {
  accept: {
    id: 'app.components.product-item-controls.accept',
    defaultMessage: 'Accept',
  },
}

export default defineMessages(messages)
